import { EUROPACE_PROCESS_PLATFORMS } from 'cpool-constants';
import { LoanRequest_DocumentsRecorded } from 'cpool-events';
import { schemaApplicantAttributionBoth, schemaId } from 'cpool-schemas';
import { z } from 'zod';

import {
    schemaRecordedDocumentsEuropaceUploadFailed,
    schemaRecordedDocumentsEuropaceUploadNotRequested,
    schemaRecordedDocumentsEuropaceUploadPending,
    schemaRecordedDocumentsEuropaceUploadSuccess,
} from './discriminatedUnions';

// export type RecordedDocumentsTableSchema = {
//     documents: Array<
//         EventSchema<LoanRequest_DocumentsRecorded>['documents'][number] & {
//             accepted?: boolean | null;
//             acceptedDate?: number | null;
//             attribution: string;
//             date: number;
//             uploadedTo?: {
//                 europace?:
//                     | { uploadStatus: typeof OFFER_DOCUMENT_UPLOAD_STATUSES.SUCCESS; uploadedAt: number }
//                     | {
//                           uploadStatus:
//                               | typeof OFFER_DOCUMENT_UPLOAD_STATUSES.PENDING
//                               | typeof OFFER_DOCUMENT_UPLOAD_STATUSES.FAILED;
//                       };
//             };
//         }
//     >;
//     id: string;
// };

export const RecordedDocumentsTableDefinitionZod = z.object({
    documents: z.array(
        LoanRequest_DocumentsRecorded.prototype.getSchema().shape.documents.element.merge(
            z.object({
                accepted: z.boolean().nullish(),
                acceptedDate: z.number().nullish(),
                attribution: schemaApplicantAttributionBoth,
                date: z.number(),
                uploadedTo: z.object({
                    europacePlatform: z
                        .record(
                            z.nativeEnum(EUROPACE_PROCESS_PLATFORMS),
                            z.discriminatedUnion('uploadStatus', [
                                schemaRecordedDocumentsEuropaceUploadSuccess,
                                schemaRecordedDocumentsEuropaceUploadPending,
                                schemaRecordedDocumentsEuropaceUploadFailed,
                                schemaRecordedDocumentsEuropaceUploadNotRequested,
                            ]),
                        )
                        .optional(),
                }),
            }),
        ),
    ),
    id: schemaId,
});

export type RecordedDocumentsTableSchema = z.infer<typeof RecordedDocumentsTableDefinitionZod>;
